// @flow

import React, { type Node } from 'react';
import { getMealVoucherInfoFromQueryParams } from '../../../meal-voucher/info';
import { VrPage } from './vr-page';
import { SodexoPage } from './sodexo-page';

export function MealVoucherPage(): Node {
  const {
    mealVoucherBrand,
  } = getMealVoucherInfoFromQueryParams();

  switch (mealVoucherBrand) {
    case 'vr':
      return <VrPage />;
    case 'sodexo':
      return <SodexoPage/>;
    default:
      throw new Error(`Meal voucher brand "${mealVoucherBrand}" is not supported.`);
  }

}
